import { Globe } from 'lucide-react';
import SwipeOpinionLogo from '../components/brand/SwipeOpinionLogo';

export default function GeoBlockedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#5B4FE8] via-[#4338CA] to-teal-500 relative overflow-hidden px-4">
      <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-white/10" />
      <div className="absolute bottom-32 right-16 w-48 h-48 rounded-full bg-white/5" />
      <div className="relative max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 text-center">
        <SwipeOpinionLogo variant="full" className="justify-center mb-4" markClassName="w-5 h-5" wordmarkClassName="text-base font-semibold text-navy" />
        <div className="mx-auto w-16 h-16 rounded-full bg-[#F3F0FF] flex items-center justify-center mb-4">
          <Globe className="w-8 h-8 text-[#5B4FE8]" />
        </div>
        <h1 className="text-2xl font-semibold text-[#111827] mb-3">
          We&rsquo;re not available in your country yet
        </h1>
        <p className="text-[#6B7280] mb-2">
          Swipe Opinion is currently only available in the United States.
        </p>
        <p className="text-[#6B7280] mb-6 text-sm">
          We&rsquo;re working hard to expand to new countries &mdash; check back soon!
        </p>
        <a
          href="mailto:support@swipeopinion.com"
          className="inline-block text-sm text-[#5B4FE8] hover:text-[#4338CA] font-medium"
        >
          Questions? Contact support
        </a>
      </div>
    </div>
  );
}
